import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type { TCriarAtendimentoResponse } from '@/features/atendimento/interfaces'
import { CriarAtendimentoService } from '@/features/atendimento/services'
import { atendimentoKeys } from '@/features/atendimento/utils/queries'

export const useCriarAtendimento = () => {
  return useMutation<TCriarAtendimentoResponse, AxiosError, string, unknown>({
    mutationKey: atendimentoKeys.criarAtendimento(),
    mutationFn: async (clienteId: string) => new CriarAtendimentoService().execute(clienteId),
  })
}
